import { inject, observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button } from 'telia-front-react';
import MobileBusinessStore from '../../stores/MobileBusinessStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Package } from '../MobileBusinessInterfaces';

interface Props {
  index: number;
  mobilePackage: Package;
  mobileBusinessStore?: MobileBusinessStore;
}

@observer
class PackageSelectionButton extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private onClick() {
    const { mobilePackage, mobileBusinessStore } = this.props;
    mobileBusinessStore.selectPackage(mobilePackage);
  }

  public render() {
    const translate = this.context.translate;
    const { mobilePackage, index } = this.props;
    const selectedCapacity = mobilePackage.capacity + translate(`mobileBusiness.capacityUnit.${mobilePackage.capacityUnit}`);

    return (
      <AnalyticsTrigger
        trigger={{
          id: `CTA - Form - ${selectedCapacity}`,
          callback: 'onClick',
        }}
      >
        <Button
          aria-describedby={`card-title-${index}`}
          block={true}
          type="expressive"
          text={translate('mobileBusiness.interested')}
          iconRight="#arrow-right"
          onClick={() => this.onClick()}
        />
      </AnalyticsTrigger>
    );
  }
}

export default inject('mobileBusinessStore')(PackageSelectionButton);
